/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { styled } from 'fierry/react';

import BoardRanges from 'solis/logic/board/ranges';
import AccountCass from 'solis/logic/account/cass';


const WIDTH = 138;
const HEIGHT = 24;

const INSET = 3.5;
const SPAN = WIDTH - 2 * INSET;

const TRACK_Y = 5;
const TRACK_HEIGHT = 6;

const NOTCH_WIDTH = 2;

const LABEL_Y = 22;


const Track = styled.rect`
  fill: var(--gray-a3);
`;


const Fill = styled.rect`
  fill: var(--gray-9);
`;


const Label = styled.text`
  font-size: 9px;
  font-weight: 500;
  fill: var(--gray-9);
  font-variant-numeric: tabular-nums;
`;


const formatPercent = (ratio) =>
{
  return (ratio > 0 ? '+' : '−') + Math.round(Math.abs(ratio) * 100) + '%';
};


const getStrengths = (board, account, galaxy) =>
{
  const territory = new AccountCass(account, galaxy).getScore().cass.territory;

  return new BoardRanges(board).getUsersByAttachDate().map(user => galaxy.getScore(user.cass.id).cass.territory / territory - 1);
};


export default ({ board, account, galaxy }) =>
{
  const settings = board.getSettings();

  const left = settings.getMinBoardTerritoryRatio() - 1;
  const right = settings.getMaxBoardRisk();

  const toX = (ratio) => INSET + (Math.min(Math.max(ratio, left), right) - left) / (right - left) * SPAN;

  const strengths = getStrengths(board, account, galaxy);

  const from = toX(Math.min(...strengths)) - INSET;
  const to = toX(Math.max(...strengths)) + INSET;

  const mask = 'strength-' + board.cass.id;

  return (
    <svg width = {WIDTH} height = {HEIGHT} viewBox = {`0 0 ${WIDTH} ${HEIGHT}`}>
      <mask id = {mask}>
        <rect x = '0' y = '0' width = {WIDTH} height = {HEIGHT} fill = 'white' />
        <rect x = {toX(0) - NOTCH_WIDTH / 2} y = '0' width = {NOTCH_WIDTH} height = {HEIGHT} fill = 'black' />
      </mask>
      <g mask = {`url(#${mask})`}>
        <Track x = '0' y = {TRACK_Y} width = {WIDTH} height = {TRACK_HEIGHT} rx = '3' />
        <Fill x = {from} y = {TRACK_Y} width = {to - from} height = {TRACK_HEIGHT} rx = '3' />
      </g>
      <Label x = '0' y = {LABEL_Y}>{formatPercent(left)}</Label>
      <Label x = {WIDTH} y = {LABEL_Y} textAnchor = 'end'>{formatPercent(right)}</Label>
    </svg>
  );
};
